import {Injectable} from '@angular/core';
import {Apollo} from 'apollo-angular';
import {SocketServices} from '../../CoreModule/services/socket.services';
import {CategoriaMarcaModel} from '../models/marca.model';
import {Observable} from 'rxjs';

@Injectable()
export class MarcasServices {

  public obsGetMarcas: Observable<any>;
  public obsGetCategoriasDB: Observable<any>;
  public obsSaveCategoriaMarcas: Observable<any>;
  public obsDeleteCategoriaMarcas: Observable<any>;
  public obsGetCategoriasMarcas: Observable<any>;
  public obsGetCategoriaMarca: Observable<any>;

  constructor(private apollo: Apollo, private ss: SocketServices) {
    this.obsGetMarcas = this.ss.registrarEvento("sendMarcas");
    this.obsGetCategoriasDB = this.ss.registrarEvento("sendCategoriaDB");
    this.obsSaveCategoriaMarcas = this.ss.registrarEvento("rSaveCategoriaMarcas");
    this.obsDeleteCategoriaMarcas = this.ss.registrarEvento("deletCategoriaMarcas");
    this.obsGetCategoriasMarcas = this.ss.registrarEvento("sendCategoriasMarcas");
    this.obsGetCategoriaMarca = this.ss.registrarEvento("sendCategoriaMarca");
  }

  getMarcas() {
    this.ss.enviarEvento('getMarcas', {});
  }

  getCategoriasDB() {
    this.ss.enviarEvento('getCategoriasDB', {});
  }

  saveCategoriaMarcas(categoriaMarca: CategoriaMarcaModel) {
    this.ss.enviarEvento('saveCategoriaMarcas', {categoria: categoriaMarca});
  }

  deleteCategoriaMarcas(id: any) {
    this.ss.enviarEvento('deleteCategoriaMarcas', {id: id});
  }

  getCategoriasMarcas() {
    this.ss.enviarEvento('getCategoriasMarcas', {});
  }

  getCategoriaMarca(id: any) {
    this.ss.enviarEvento('getCategoriaMarca', {id: id});
  }
}
